import React from 'react';

export function Mobile() {
    return (
        <svg width="22" height="31" viewBox="0 0 22 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.25 0H2.75C1.1 0 0 1.12727 0 2.81818V28.1818C0 29.8727 1.1 31 2.75 31H19.25C20.9 31 22 29.8727 22 28.1818V2.81818C22 1.12727 20.9 0 19.25 0ZM14.3 28.1818C14.3 28.7455 13.75 29.3091 13.2 29.3091H8.8C8.25 29.3091 7.7 28.7455 7.7 28.1818V27.6182C7.7 27.0545 8.25 26.4909 8.8 26.4909H13.2C13.75 26.4909 14.3 27.0545 14.3 27.6182V28.1818ZM19.25 23.6727C19.25 24.2364 18.7 24.8 18.15 24.8H3.85C3.3 24.8 2.75 24.2364 2.75 23.6727V3.94545C2.75 3.38182 3.3 2.81818 3.85 2.81818H18.15C18.7 2.81818 19.25 3.38182 19.25 3.94545V23.6727Z" fill="currentColor" />
        </svg>
    );
}
